import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const Expense = () => {
    const navigate = useNavigate();
	const [expenses, setExpenses] = useState([]);
    const [formData, setFormData] = useState({
        Empid:'',
        companyphone: '',
        companygst:'',
        companyname:'',
        companyemail: '',
        date: '',
        companylocation: '',
        address: '',
    });

    // Fetching Data
    useEffect(() => {
        axios.get("https://api.trucoo.in/company/addcompany/")
            .then(response => {
                setExpenses(response.data)
				console.log("Form Submitted: ", response.data);
            })
            .catch(error => {
                console.error("There was an error in Fecthing Data", error)
            })
    }, []);
    console.log(expenses);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        

        console.log("Form Submitted: ", formData);

        // Fetch functionality
        axios.post('https://api.trucoo.in/company/addcompany/', formData, {

            headers: {
                'Content-Type': 'application/json'
            }

        })
            .then(response => {
                if (response.data.status === "success") {

                    console.log(response.data);
                       navigate(`/addservice?id=${response.data.seviceId}`);
                  } else {
                    console.error(response.data);
                  }

            })
            .catch(error => {
                console.error("There was an Error");
            });

        console.log('Form Data:', formData);

    }
    return(

        <>
        <Header />
        <Sidebar />


        <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<div class="row">
                       
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Company</h4>
								    <hr class="my-15" />

								    <div class="row">

										{/* category*/}
								        <div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Employee ID</label>
									            <input type="text" class="form-control" name="Empid" value={formData.Empid} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}

                                        {/* category*/}
								        <div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Company Name</label>
									            <input type="text" class="form-control" name="companyname" value={formData.companyname} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}
                                         {/* category*/}
								        <div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Company Gst</label>
									            <input type="text" class="form-control" name="companygst" value={formData.companygst} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}

                                        {/* category*/}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Company Email</label>
									            <input type="email" class="form-control" name="companyemail" value={formData.companyemail} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}
                                         {/* category*/}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Company PhoneNumber</label>
									            <input type="number" class="form-control" name="companyphone" value={formData.companyphone} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}

										{/* date */}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Date</label>
									            <input type="date" class="form-control" name="date" value={formData.date} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the date*/}

										 {/* category*/}
                                         <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Company Location</label>
									            <input type="text" class="form-control" name="companylocation" value={formData.companylocation} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}


                                        {/* description */}
                                        <div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Address</label>
                                                <textarea rows="2" class="form-control" name="address" value={formData.address} onChange={handleChange}></textarea>
									        </div>
								        </div>
                                        {/* description end */}

								    </div>
                        
                                </div>
                            </div>
                        </div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1"><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary" onClick={handleSubmit}><i class="ti-save-alt"></i> Save</button>
										    </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
				</div>
			</section>
		</div>
	</div>


        </>
    )

    
}

export default Expense;